import React, { useState } from 'react';
import ConfirmModal from '../UI/Modal/confirmModal';
import { deleteOpenRouterWorkspace } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';
import { toast } from 'react-toastify';

const DeleteWorkspaceModal = ({
    setSelectedAction,
    selectedWorkspace,
    setSelectedWorkspace,
    getWorkspaces,
}) => {
    const { userData } = useUserContext();
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        if (!selectedWorkspace?.org_id) return;
        setLoading(true);
        try {
            const result = await deleteOpenRouterWorkspace(
                userData?.token,
                selectedWorkspace.org_id,
                userData?.selectedOrganization?.org_token
            );
            if (result?.status) {
                toast.success(result.message || 'Workspace unassigned successfully.');
                await getWorkspaces();
                setSelectedAction('');
                setSelectedWorkspace(null);
            }
        } catch (error) {
            console.error('Delete workspace error:', error);
            const msg =
                error?.response?.data?.message ||
                error?.message ||
                'Failed to unassign OpenRouter workspace.';
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfirmModal
            title="Unassign OpenRouter Workspace"
            description={`Are you sure you want to remove the OpenRouter workspace configuration for "${selectedWorkspace?.name || selectedWorkspace?.org_id}"? Future AI operations for this organization will automatically provision a new workspace or require manual assignment.`}
            ConfirmText="Unassign Workspace"
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={handleDelete}
        />
    );
};

export default DeleteWorkspaceModal;

